export enum R2VehicleDefaultMaxValuesType {
    WEIGHT="WEIGHT",
    VOLUME="VOLUME"
}